module.exports = __webpack_public_path__ + "img/gea-logo.089ee03d.png";